// File: components/scenario-planner-details/mass-edit-custom-selection.modal.tsx

import { useCallback, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import '../mass-edit-sidebar/mass-edit-sidebar.component.scss';
import { FilterPaneHeaderStandAloneComponent } from '../../../../components/filters/components/filter-pane-header/filter-pane-header-stand-alone.component';
import { useConcatenateFilterSelection } from '../../../../components/filters/hooks/common.hook';
import { useFilterContext } from '../../../../components/filters/provider/filter.provider';
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import {
  useAppFilterDict,
  useAppFindFilters,
} from '../../../../hooks/filters/use-app-filters.hook';
import { useMediaClassName } from '../../../../hooks/use-window-resize.hook';
import { FILTERS_ADDITIONAL } from '../scenario-planner-new/scenario-planner.common';

export interface MassEditCustomSelectionModalProps {
  onClose: () => void;
  onConfirm: (filterSelection: FilterSelectedValue[]) => void;
  show: boolean;
  scenarioPlannerFilterSel: FilterSelectedValue[];
  defaultFilterSelection?: FilterSelectedValue[];
}

export const MassEditCustomSelectionModalComponent = ({
  onClose,
  onConfirm,
  show,
  scenarioPlannerFilterSel,
  defaultFilterSelection = [],
}: MassEditCustomSelectionModalProps) => {
  const mediaClassName = useMediaClassName();
  const [customFilterSelection, setCustomFilterSelection] = useState<
    FilterSelectedValue[]
  >(defaultFilterSelection);
  const scenarioPlannerFilterSelection = useConcatenateFilterSelection(
    scenarioPlannerFilterSel,
    customFilterSelection,
  );
  // Gets global filter metadata to be used by the FilterPaneHeaderStandAloneComponent
  const filters = useAppFindFilters(useFilterContext(), FILTERS_ADDITIONAL);
  const filterDict = useAppFilterDict(filters);

  const onSelectHandler = useCallback(
    (selectedValue: FilterSelectedValue) => {
      setCustomFilterSelection((value) =>
        value
          ?.filter((i) => i.id !== selectedValue.id)
          .concat(selectedValue)
          .map((i) => ({
            ...i,
            matchStrategy: filterDict[i.id].defaultSelectedValue?.matchStrategy,
          })),
      );
    },
    [filterDict],
  );

  const handleConfirm = useCallback(() => {
    //console.log("Selected Filters:", customFilterSelection);
    onConfirm(customFilterSelection);
    onClose();
  }, [customFilterSelection, onConfirm, onClose]);
  return (
    <Modal
      className={`${mediaClassName} scenario-planner-modal mass-edit-custom-selection-modal`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onClose}
    >
      <Modal.Header closeButton className="d-flex justify-content-between">
        <Modal.Title className="scenario-planner-modal-headertitle d-flex justify-content-start align-items-center">
          Select What to Edit
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row mb-4">
            <div className="col">
              {customFilterSelection && (
                <FilterPaneHeaderStandAloneComponent
                  filterSelection={scenarioPlannerFilterSelection}
                  onSelect={onSelectHandler}
                  variant="simple"
                  filters={filters}
                  defaultLabel="Select"
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col d-flex justify-content-end gap-4">
              <button className="btn-default" onClick={onClose}>
                Cancel
              </button>
              <button className="btn-run" onClick={handleConfirm}>
                Confirm Selection
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MassEditCustomSelectionModalComponent;
